/* SoFly Accounts is the store's primary sign-in. Shopify retains cart and payment processing. */
(() => {
  'use strict';
  const accounts = 'https://account.sofly.io';
  let authenticated = false;
  const route = path => path.replace(/^\/[a-z]{2}(?:-[A-Za-z]{2})?(?=\/)/, '');
  function storePath() {
    if (route(location.pathname).startsWith('/account')) return '/';
    const query = new URLSearchParams(location.search), keep = new URLSearchParams();
    for (const key of ['q', 'variant', 'page', 'sort_by', 'view']) if (query.has(key)) keep.set(key, query.get(key));
    return location.pathname + (keep.size ? `?${keep}` : '');
  }
  function destination(mode = 'login') {
    if (mode === 'account' || (authenticated && mode !== 'register')) return `${accounts}/portal/index.html?section=account`;
    const url = new URL(mode === 'register' ? '/register' : '/login', accounts);
    url.searchParams.set('store_return', storePath());
    return url.href;
  }
  function updateLinks() {
    for (const link of document.querySelectorAll('[data-sf-account-link], [data-sf-login-link]')) {
      link.href = destination(link.dataset.sfLoginMode || 'login');
      link.removeAttribute('target');
    }
  }
  function legacyMode(link) {
    if (document.querySelector('[data-sf-legacy-link]')) return null;
    try {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin) return null;
      const path = route(url.pathname);
      if (/^\/account\/(?:register)\/?$/.test(path)) return 'register';
      if (/^\/account\/(?:login|recover|reset|activate)(?:\/|$)/.test(path)) return 'login';
      if (/^\/account(?:\/addresses|\/orders(?:\/[^/]+)?)?\/?$/.test(path)) return 'account';
    } catch { /* Leave other destinations alone. */ }
    return null;
  }
  function ready() {
    updateLinks();
    const redirect = document.querySelector('[data-sf-account-redirect]');
    if (redirect && !window.Shopify?.designMode) location.replace(destination(redirect.dataset.sfAccountMode));
  }
  document.addEventListener('sofly:account-state', event => { authenticated = event.detail?.authenticated === true; updateLinks(); });
  document.addEventListener('shopify:section:load', updateLinks);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const mode = legacyMode(link);
    if (mode) { link.href = destination(mode); link.removeAttribute('target'); }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true}); else ready();
})();
